/**
 * Shop JS
 */

// CSS
import styles from '../scss/shop.scss';

const $ = window.jQuery;
